import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule} from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER } from '@angular/core';
import { PortalModule } from '@angular/cdk/portal';
import 'hammerjs';
import { ChartsModule } from 'ng2-charts';


//angular material
import {LayoutModule} from '@angular/cdk/layout';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatMenuModule} from '@angular/material/menu';
import {MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatTableModule} from '@angular/material/table';
import {MatSelectModule} from '@angular/material/select';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {MatDividerModule} from '@angular/material/divider';
import {MatTreeModule} from '@angular/material/tree';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

import {MatRadioModule} from '@angular/material/radio';
import {MatStepperModule} from '@angular/material/stepper';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
//SWIPER
import { SwiperModule } from 'swiper/angular';

//IDLE

import {NgIdleKeepaliveModule} from '@ng-idle/keepalive'; // esto incluye el núcleo NgIdleModule pero incluye proveedores keepalive para una fácil conexión
import {MomentModule} from 'angular2-moment'; // opcional, proporciona canalizaciones de estilo de momento para el formato de fecha


//firebase

import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';

import { environment } from '../environments/environment';

//PDFMAKE

import {PdfMakeWrapper} from 'pdfmake-wrapper';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
PdfMakeWrapper.setFonts(pdfFonts);

//MASK

import { NgxMaskModule, IConfig } from 'ngx-mask'

const maskConfig: Partial<IConfig> = {
  validation: false,
};
//RUTAS

import { APP_ROUTING } from './app.rutas';

//SERVICIOS
import { nkServices } from './componentes/shared/servicios/app.nkservicios.services';
import { AuthGuardService } from '../app/componentes/shared/servicios/auth-guard.service';
import {NgxPermissionsGuard} from 'ngx-permissions';
import { HashKeyServices } from './componentes/shared/servicios/app.hashkey.services';
import { PdfServices } from './componentes/shared/servicios/app.pdf.services';


//COMPONENTES

import { AppComponent } from './app.component';
import { InicioComponent } from './componentes/shared/inicio/inicio.component';
import { FooterComponent } from './componentes/shared/footer/footer.component';
import { NavbarComponent } from './componentes/shared/navbar/navbar.component';
import { FormmMsgComponent } from './componentes/shared/modal/formm-msg/formm-msg.component';
import { FormLoginComponent } from './componentes/shared/modal/form-login/form-login.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { FormSpinnerComponent } from './componentes/shared/modal/form-spinner/form-spinner.component';
import { QRCodeModule } from 'angular2-qrcode';
import { ConnectionServices } from './componentes/shared/servicios/app.connection.services';
import { FormVersionComponent } from './componentes/shared/modal/form-version/form-version.component';
import { PuntoporcomaPipe } from './componentes/shared/pipes/puntoporcoma.pipe';
import { AppUtilService } from './componentes/shared/servicios/app.util.service';
import { AtributosService } from './componentes/shared/servicios/atributos.service';
import { PipeServicesPipe } from './pipes/pipe-services.pipe';
import { FormRecuperacionComponent } from './componentes/shared/modal/form-recuperacion/form-recuperacion.component';
import { PaginaComponent } from './componentes/shared/pagina/pagina.component';
import { HeaderPagComponent } from './componentes/shared/pagina/pagina-atrb/header-pag/header-pag.component';
import { FooterPagComponent } from './componentes/shared/pagina/pagina-atrb/footer-pag/footer-pag.component';
import { HeaderBannerComponent } from './componentes/shared/pagina/pagina-atrb/header-banner/header-banner.component';
import { FormRegistroAppComponent } from './componentes/shared/modal/form-registro-app/form-registro-app.component';
import { FormPerfilComponent } from './componentes/shared/modal/form-perfil/form-perfil.component';
import { FormTestComponent } from './componentes/shared/modal/form-test/form-test.component';
import { FormTestPreguntasComponent } from './componentes/shared/modal/form-test-preguntas/form-test-preguntas.component';
import { SplitPipePipe } from './componentes/shared/pipes/split-pipe.pipe';
import { FormPasarelaComponent } from './componentes/shared/modal/form-pasarela/form-pasarela.component';
import { AppRouterService } from './componentes/shared/servicios/app.router.service';
import { MediaServicesService } from './componentes/shared/servicios/media-services.service';
import { AvatarComponent } from './componentes/shared/pagina/pagina-atrb/avatar/avatar.component';

export function loadCrucialData() {
  return function() {
    // or use UserService
    return delay(1000);
  }
}

export function delay(delay: number) {
  return function() {
    return new Promise(function(resolve) {
        setTimeout(resolve, delay);
    });
  }
}

@NgModule({
  declarations: [
    AppComponent,
    InicioComponent,
    FooterComponent,
    NavbarComponent,
    FormmMsgComponent,
    FormLoginComponent,
    FormSpinnerComponent,
    FormVersionComponent,
    PuntoporcomaPipe,
    PipeServicesPipe,
    FormRecuperacionComponent,
    PaginaComponent,
    HeaderPagComponent,
    FooterPagComponent,
    HeaderBannerComponent,
    FormRegistroAppComponent,
    FormPerfilComponent,
    FormTestComponent,
    FormTestPreguntasComponent,
    SplitPipePipe,
    FormPasarelaComponent,
    AvatarComponent
  ],
  imports: [
    BrowserModule,
    MomentModule,
    NgIdleKeepaliveModule.forRoot(),
    APP_ROUTING,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatDialogModule,
    MatInputModule,
    MatSnackBarModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    MatTableModule,
    MatSelectModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatToolbarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDividerModule,
    MatTreeModule,
    MatCheckboxModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    MatTooltipModule,
    MatAutocompleteModule,
    NgxMaskModule.forRoot(maskConfig),
    LayoutModule,
    MatProgressSpinnerModule,
    ChartsModule,
    QRCodeModule,
    PortalModule,
    MatRadioModule,
    MatStepperModule,
    MatSlideToggleModule,
    MatSidenavModule,
    MatProgressBarModule,
    SwiperModule,
    MatTabsModule,
    MatExpansionModule
  ],
  exports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatIconModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatDialogModule,
    MatInputModule,
    MatSnackBarModule,
    MatTableModule,
    MatSelectModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatToolbarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDividerModule,
    MatTreeModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    LayoutModule,
    MatProgressSpinnerModule,
    PuntoporcomaPipe
  ],
  providers: [
    nkServices,
    AuthGuardService,
    NgxPermissionsGuard,
    ConnectionServices,
    HashKeyServices,
    PdfServices,
    AppUtilService,
    AtributosService,
    MediaServicesService,
    AppRouterService,
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: loadCrucialData()
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
